import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { AuthenticationService } from "../../_services/authentication.service";
import { AlertService } from "../../_services/alert.service";

/** The login as it is on `main`, routed to while the `twoFactorLogin` flag is off */
@Component({
  moduleId: module.id,
  templateUrl: "legacy-login.component.html",
  styleUrls: ["legacy-login.component.scss"],
})
export class LegacyLoginComponent implements OnInit {
  model: any = {};
  loading = false;
  returnUrl: string;
  isPasswordVisible = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private sessionManager: SessionManagerService
  ) { }

  ngOnInit() {
    localStorage.removeItem("allowShowPopup");
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
  }

  keyPressed(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      this.login();
    }
  }

  forgotPassword() {
    this.router.navigate(["/forgotpassword"]);
  }

  toggleVisibility(event: MouseEvent) {
    event.preventDefault();
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  login() {
    this.loading = true;

    this.authenticationService
      .legacyLogin(this.model.username, this.model.password)
      .subscribe(
        (data) => {
          this.sessionManager.recordUserLoginTime();
          this.router.navigate([this.returnUrl]);
        },
        (error) => {
          if (error && error.status !== 200) {
            if (error.status === 504 || error.status === 502) {
              this.alertService.error("שגיאה בהתחברות לשרת");
            } else {
              try {
                const body = error.json && error.json();
                this.alertService.error(
                  (body && body.statusText) || error.statusText
                );
              } catch (err) {
                this.alertService.error(err);
              }
            }
            this.loading = false;
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/login/legacy-login/legacy-login.component.ts